import "@/styles/tailwind.sass"
import "@/styles/element/index.scss"

import { DateTime, Settings } from "luxon"
import ElementPlus, { ElMessage, ElMessageBox, ElNotification } from "element-plus"
import * as ElementPlusIconsVue from "@element-plus/icons-vue"
import router, { addWildcardRoute } from "@/routers"

import App from "@/App.vue"
import sentryService from "@/services/sentry-service"
import store from "@/store"
import { createApp } from "vue"
import { VueQueryPlugin } from "@tanstack/vue-query"
import { queryClient } from "@/query-client"
import { appointmentModule } from "@/modules/appointments"
import { asyncVisitModule } from "@/modules/async-appointment"
import { authModule } from "@/modules/auth"
import { chartingModule } from "@/modules/charting"
import { medicationModule } from "@/modules/medication"
import { occupationalHealthModule } from "@/modules/occupational-health"
import { patientConversationsModule } from "@/modules/patient-conversations"
import { providersModule } from "@/modules/providers"
import { registerModule } from "@/module-register"
import { initializeVitePreloadErrorHandler } from "@common/services/vite-preload-error-service"
import { schedulingModule } from "@/modules/scheduling"
import { screeningModule } from "@/modules/screening"
import { taskModule } from "@/modules/tasks"
import { timezoneModule } from "@/modules/timezone"

// Date formats are clinical data, so they follow the practice, not the browser's locale.
// Without this, Luxon's macro tokens render day/month on non-US machines.
Settings.defaultLocale = "en-US"

const app = createApp(App)

app.use(store)
app.use(VueQueryPlugin, { queryClient })
app.use(ElementPlus)

for (const [name, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(name, component)
}

app.config.globalProperties.$luxon = DateTime
app.config.globalProperties.$luxonSettings = Settings
app.config.globalProperties.$message = (options) => ElMessage({ duration: 6000, showClose: true, ...options })
app.config.globalProperties.$msgbox = ElMessageBox
app.config.globalProperties.$confirm = ElMessageBox.confirm
app.config.globalProperties.$alert = ElMessageBox.alert
app.config.globalProperties.$prompt = ElMessageBox.prompt
app.config.globalProperties.$notify = ElNotification

sentryService.initializeSentry(app)
initializeVitePreloadErrorHandler()

registerModule(app, authModule)
registerModule(app, occupationalHealthModule)
registerModule(app, medicationModule)
registerModule(app, taskModule)
registerModule(app, timezoneModule)
registerModule(app, appointmentModule)
registerModule(app, chartingModule)
registerModule(app, schedulingModule)
registerModule(app, providersModule)
registerModule(app, asyncVisitModule)
registerModule(app, screeningModule)
registerModule(app, patientConversationsModule)

addWildcardRoute()

// Router 4 starts the initial navigation on install, so all module routes must be registered first
app.use(router)

store.dispatch("me/init")
app.mount("#app")
